import { styled } from '@linaria/react';

export const Details = styled.ul`
	display: grid;
	padding: 0;
	gap: 1.6rem 0.8rem;
	grid-template-columns: 1fr 1fr;
	list-style: none;
`;

export const Detail = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
